import BobrovnikPage from "../../../components/customOrgs/senzacni/BobrovnikPage";
export default function Bobrovnik() {
    return <BobrovnikPage />;
}
